@if (renownedBranding()) {
  <a class="inline-flex items-center" [href]="renownedUrl | async" rel="noopener noreferrer">
    <img alt="Renowned" class="md:hidden" [src]="'logos/renowned-logo-primary.svg' | staticImageUrl" width="188" height="36" />
    <img
      alt="Renowned"
      class="hidden md:block xl:hidden"
      [src]="'logos/renowned-logo-primary.svg' | staticImageUrl"
      width="120"
      height="36"
    />
    <img alt="Renowned" class="hidden xl:block" [src]="'logos/renowned-logo-primary.svg' | staticImageUrl" width="120" height="36" />
  </a>
} @else {
  <a class="inline-flex items-center" routerLink="/">
    @if (loginHeader()) {
      <img alt="RateMyAgent" class="md:hidden" [src]="'logos/rma-logo-blue.svg' | staticImageUrl" width="188" height="36" />
      <img alt="RateMyAgent" class="hidden md:block xl:hidden" [src]="'logos/rma-logo-blue.svg' | staticImageUrl" width="120" height="36" />
      <img alt="RateMyAgent" class="hidden xl:block" [src]="'logos/rma-logo-blue.svg' | staticImageUrl" width="120" height="36" />
    } @else {
      <img alt="RateMyAgent" class="md:hidden" [src]="'logos/logo-compact-dark.svg' | staticImageUrl" width="32" height="36" />
      <img alt="RateMyAgent" class="hidden md:block xl:hidden" [src]="'logos/logo-stacked.svg' | staticImageUrl" width="64" height="36" />
      <img alt="RateMyAgent" class="hidden xl:block" [src]="'logos/logo-dark.svg' | staticImageUrl" width="120" height="36" />
    }
  </a>
}
